import { render, staticRenderFns } from "./CompetitorEditorPopup.vue?vue&type=template&id=2679337d&lang=html"
import script from "./CompetitorEditorPopup.vue?vue&type=script&lang=js"
export * from "./CompetitorEditorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports